/* global grecaptcha */

const SITE_KEY = "6Leb1M4rAAAAAP_gRcAyMiOo99-j6eqQajKuMlB9";

export const obtenerRecaptcha = () => {
  return new Promise((resolve, reject) => {

    if (!window.grecaptcha) {
      reject("reCAPTCHA no cargado");
      return;
    }

    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(
        SITE_KEY,
        {
          action: "consultarCedula"
        }
      )
      .then(resolve)
      .catch(reject);
    });
  });
};
